<template>
  <el-main class="login-main">
    <div class="login-header">
      <div class="login-header__wrap">
        <SiteName position="login" />
      </div>
    </div>
    <div class="login-body">
      <el-carousel height="500px" arrow="never" :interval="4000">
        <el-carousel-item v-for="(item, index) in carouselImgs" :key="index">
          <a
            href="#"
            :style="{ background: 'url(' + item.img + ') center top no-repeat' }"
          ></a>
        </el-carousel-item>
      </el-carousel>
      <div class="login-form">
        <div class="login-mode--wrapper" style="margin: 0 0 32px 0">
          <el-button
            type="text"
            role="tab"
            @click="handleSelectAccountLogin"
            :class="{ 'login-model--account': true, active: loginModel === 'account' }"
            >账号登录</el-button
          >
          <!-- <div class="cut">|</div>
            <el-button
              type="text"
              role="tab"
              @click="handleSelectPasscodeLogin"
              :class="{'login-model--passcode': true, active: loginModel === 'passcode'}"
            >验证码登录</el-button> -->
        </div>
        <!-- 账号登录 -->
        <el-form
          v-show="loginModel === 'account'"
          ref="accountForm"
          :model="accountForm"
          :rules="accountFormRules"
        >
          <el-form-item prop="account">
            <el-input
              v-noSpace
              v-model="accountForm.account"
              placeholder="请输入手机号/登录账号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" style="margin-bottom: 0">
            <el-input
              v-noSpace
              type="password"
              v-model="accountForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <div class="login-error-info" v-show="isLoginErrorInfo.isError">
            {{ isLoginErrorInfo.msg }}
          </div>
        </el-form>
        <!-- 验证码登录 -->
        <el-form
          v-show="loginModel === 'passcode'"
          ref="passcodeForm"
          :model="passcodeForm"
          :rules="passcodeFormRules"
        >
          <el-form-item prop="account">
            <el-input
              v-noSpace
              v-model="passcodeForm.account"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="verificationCode" style="margin-bottom: 0">
            <el-row :gutter="16">
              <el-col :span="12">
                <el-input
                  v-noSpace
                  v-model="passcodeForm.verificationCode"
                  placeholder="短信验证码"
                  @keyup.enter.native="handleLogin"
                ></el-input>
              </el-col>
              <el-col :span="12">
                <el-button
                  style="width: 100%"
                  plain
                  :disabled="phoneMsgDisabled"
                  @click="handleSendPhoneCode"
                  >{{ phoneCode.msg }}</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
          <div class="login-error-info" v-show="isLoginErrorInfo.isError">
            {{ isLoginErrorInfo.msg }}
          </div>
        </el-form>
        <div>
          <el-button
            type="primary"
            :disabled="loginDisabled"
            style="width: 100%"
            :loading="loginbtnLoading"
            @click="handleLogin"
            >登 录</el-button
          >
          <div class="login-mode--wrapper">
            <!-- <el-button type="text" role="tab" class="login-function-btn" @click="handleRegister">立即注册</el-button> -->
            <!-- <el-button type="text" role="tab" class="login-function-btn" @click="handleForgetPassword">忘记密码</el-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 身份验证输入弹窗 -->
    <el-dialog
      title="身份验证"
      width="600px"
      :visible.sync="showAuthDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="authForm.tfAuthCode = ''"
    >
      <div class="auth-tips">请输入Google Authenticator中生成的动态验证码</div>
      <el-form ref="authForm" :model="authForm" labelWidth="0">
        <el-row class="auth-row">
          <el-col :span="24">
            <el-form-item
              prop="tfAuthCode"
              :rules="{ required: true, message: '请输入验证码' }"
            >
              <CodeInput
                :code="authForm.tfAuthCode"
                @complete="handleCodeComplete"
                @enter="authLogin"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="login-btn-nav">
        <el-button type="primary" @click="authLogin">登录</el-button>
      </div>
      <div slot="footer-wrapper"></div>
    </el-dialog>
    <!-- 身份验证绑定弹窗 -->
    <el-dialog
      width="50%"
      :visible.sync="showAuth2Dialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <TwoFactorAuth :account="account" :qr="qr" @success="handleAuthSuccess" />
      <div slot="footer-wrapper"></div>
    </el-dialog>

    <div class="login-introduce">
      <div class="login-introduce__warp">
        <div class="introduce-box" v-for="(item, index) in introduceItems" :key="index">
          <div class="introduce-card">
            <div class="introduce-card--content">
              <div class="introduce-card--title">{{ item.title }}</div>
              <div class="introduce-card--tip">{{ item.content }}</div>
            </div>
            <img width="60px" height="60px" style="margin-left: 10px" :src="item.img" />
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer">
      <div class="wrap">
        <div class="copyright">
          © mycool.tv · ⽹站备案号：<a href="http://beian.miit.gov.cn"
            >京ICP备16050948号-1</a
          >
        </div>
        <div>
          <!-- <router-link to="/changelog">更新日志</router-link>&emsp;|&emsp; -->
          <a target="_blank" href="https://www.mycool.tv/">⽐利官⽹：www.mycool.tv</a>
          &emsp;|&emsp;
          <a href="#">联系我们：400 900 9690</a>
        </div>
      </div>
    </div>
  </el-main>
</template>
<script>
import loginMixin from './loginMixin.js'
import SiteName from '@/components/SiteName'
import TwoFactorAuth from '../twoFactorAuth'
import CodeInput from '@/components/common/CodeInput.vue'
import { mapGetters } from 'vuex'

const introduceItems = [
  {
    title: '全域媒介',
    content: '依托2000+酒店资源，构建多元场景新媒体平台，年覆盖超8000万旅⾏者。',
    img: require('../../assets/login-icon-advertise.png')
  },
  {
    title: '场景触达',
    content: '在旅客⼊住关键触点植⼊品牌内容，将⼴告转化为场景消费。',
    img: require('../../assets/login-icon-scene.png')
  },
  {
    title: '智能定向',
    content: '双引擎定位，多维度⽤户画像，⾼精度⼴告触达，确保品牌信息直达⽬标客群。',
    img: require('../../assets/login-icon-monitor.png')
  },
  {
    title: '数据引擎',
    content: '实时追踪曝光⾄转化全链路，依托数据反馈动态优化⼴告ROI。',
    img: require('../../assets/login-icon-analyse.png')
  }
]

export default {
  name: 'BiLiLogin',
  components: {
    TwoFactorAuth,
    SiteName,
    CodeInput
  },
  mixins: [loginMixin],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '' || undefined) {
        this.checkPhoneAndCode.passCheck = false
        callback(new Error('请输入密码'))
      } else {
        this.checkPhoneAndCode.passCheck = true
        callback()
      }
    }
    var validatorPhone = (rule, value, callback) => {
      if (this.loginModel === 'passcode') {
        if (value === '' || value === undefined) {
          this.checkPhoneAndCode.phoneCheck = false
          callback(new Error('请填写手机号'))
        } else {
          const regx = /^1(3|4|5|7|8)\d{9}$/
          if (!regx.test(value)) {
            this.checkPhoneAndCode.phoneCheck = false
            callback(new Error('请输入正确手机号'))
          } else {
            this.checkPhoneAndCode.phoneCheck = true
            callback()
          }
        }
      } else {
        if (value === '' || value === undefined) {
          this.checkPhoneAndCode.phoneCheck = false
          callback(new Error('请填写手机号/登录账号'))
        } else {
          if (value.length < 8 || value.length > 20) {
            this.checkPhoneAndCode.phoneCheck = false
            callback(new Error('输入长度为8-20字符'))
          } else {
            this.checkPhoneAndCode.phoneCheck = true
            callback()
          }
        }
      }
    }
    var validtorPhoneCode = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        this.checkPhoneAndCode.phoneCodeCheck = false
        callback(new Error('请填写验证码'))
      } else {
        this.$service
          .checkSmsCode({
            code: value,
            emailOrPhone: this.$encrypt(this.passcodeForm.account)
          })
          .then((data) => {
            if (data.isError) {
              this.checkPhoneAndCode.phoneCodeCheck = false
              callback(new Error('请输入正确短信验证码'))
            } else {
              callback()
              this.checkPhoneAndCode.phoneCodeCheck = true
            }
          })
      }
    }
    return {
      loginbtnLoading: false,
      isLoginErrorInfo: {
        isError: false,
        msg: 0
      },
      checkPhoneAndCode: {
        passCheck: false, // 密码
        phoneCheck: false, // 手机号
        phoneCodeCheck: false // 短信验证码
      },
      loginModel: 'account',
      accountForm: this.getDefaultAccountForm(),
      passcodeForm: this.getDefaultPasscodeForm(),
      accountFormRules: {
        account: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        password: [{ required: true, validator: validatePass, trigger: 'blur' }]
      },
      passcodeFormRules: {
        account: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        verificationCode: [
          { required: true, validator: validtorPhoneCode, trigger: 'blur' }
        ]
      },
      phoneCode: {
        codeCount: 60,
        msg: '发送验证码',
        timer: null,
        disabled: false
      },
      codePicUrl: 'api/captcha.jpg',
      carouselImgs: [
        {
          img: require('../../assets/banner-bili.jpeg')
        }
      ],
      introduceItems,
      authForm: {
        tfAuthCode: ''
      },
      qr: {},
      showAuthDialog: false,
      showAuth2Dialog: false,
      account: {}
    }
  },
  computed: {
    ...mapGetters(['unreadMessageNum', 'sysInfo']),
    loginDisabled() {
      let disabled = true
      disabled = false
      return disabled
    },
    phoneMsgDisabled() {
      let disabled = true
      if (
        this.passcodeForm.verificationCode &&
        this.passcodeForm.verificationCode.length === 4
      ) {
        this.$refs.passcodeForm.validateField('verificationCode')
      }
      if (this.checkPhoneAndCode.phoneCheck) {
        disabled = false
      }
      return disabled
    },
    currentForm() {
      const { loginModel, accountForm, passcodeForm } = this
      return loginModel === 'account' ? accountForm : passcodeForm
    }
  },
  watch: {
    accountForm: {
      handler() {
        this.isLoginErrorInfo.isError = false
      },
      deep: true
    }
  },
  methods: {
    getDefaultAccountForm() {
      return {
        account: undefined,
        password: undefined
      }
    },
    getDefaultPasscodeForm() {
      return {
        account: undefined,
        verificationCode: undefined
      }
    },
    handleLogin() {
      const { loginModel } = this
      const $ref =
        loginModel === 'account' ? this.$refs.accountForm : this.$refs.passcodeForm
      $ref.validate((valid) => {
        if (valid) {
          const form = this.cloneDeep(this.currentForm)
          const loginType = loginModel === 'account' ? 'account' : 'phoneCode'
          const data = {
            loginType,
            userAccount: this.$encrypt(form.account),
            password: this.$encrypt(form.password),
            phoneCode: form.verificationCode
          }
          this.loginbtnLoading = true
          this.$service.login(data).then((res) => {
            this.loginbtnLoading = false
            if (res.isError) {
              this.isLoginErrorInfo.isError = true
              this.isLoginErrorInfo.msg = res.errorMsg
              this.updateValicode()
              setTimeout(() => {
                this.isLoginErrorInfo.isError = false
              }, 4000)
              return
            }
            if (res.code === 30208) {
              this.$alert(
                '我们已收到您的开户申请，将在3个工作日内与您联系，账户审核通过后可登录后台',
                '提醒',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {}
                }
              )
              return
            }
            if (loginModel === 'account' && res.needAuth === '1') {
              if (res.identitySecret) {
                this.qr = { ...res }
                this.account = {
                  account: this.accountForm.account,
                  password: this.accountForm.password,
                  loginType
                }
                this.showAuth2Dialog = true
              } else {
                this.showAuthDialog = true
              }
            } else {
              this.handleAuthSuccess(res)
            }
          })
        }
      })
    },
    // 身份验证登录
    async authLogin() {
      const isValid = await this.$refs.authForm.validate().catch(() => {})
      if (!isValid) {
        return
      }
      const params = {
        code: this.authForm.tfAuthCode,
        userAccount: this.$encrypt(this.accountForm.account),
        password: this.$encrypt(this.accountForm.password),
        loginType: this.loginModel === 'account' ? 'account' : 'phoneCode'
      }
      this.$service.authLogin(params).then((res) => {
        this.handleAuthSuccess(res)
      })
    },
    async handleAuthSuccess(res) {
      const menus = res.authMenus.menus
      this.$appState.$set('authMenus', menus)
      const permissions = res.authMenus.permissions.reduce((result, item) => {
        result[item] = item
        return result
      }, {})
      this.$appState.$set('permissions', permissions)
      if (menus.length === 0) {
        this.$router.push({ name: 'login' })
      } else {
        const menuNames = {
          home: 'dashboard',
          putAd: 'projectOrder',
          data: 'orderBasicData',
          finance: 'FinancialIndex',
          account: 'loginAccountInfo'
        }
        const routerName = menuNames[menus[0].elId]
        await this.$service.getUserInfo()
        await this.$service.isTopPartner()
        await this.$store.dispatch('getUnreadMsgNum')
        const isShow = this.unreadMessageNum > 0
        await this.$store.dispatch('setShowMessageTip', isShow)
        this.$router.push({
          name: routerName
        })
      }
    },
    onInputAccountFormPicCode(val) {
      // eslint-disable-next-line no-useless-escape
      if (!/\ /.test(val) && val.length <= 4) {
        this.accountForm.picCode = val
      }
    },
    onInputPasscodeFormPicCode(val) {
      // eslint-disable-next-line no-useless-escape
      if (!/\ /.test(val) && val.length <= 4) {
        this.passcodeForm.picCode = val
      }
    },
    handleSelectAccountLogin() {
      this.loginModel = 'account'
      this.$refs.passcodeForm && this.$refs.passcodeForm.resetFields()
      this.isLoginErrorInfo.isError = false
      this.isLoginErrorInfo.msg = ''
    },
    handleSelectPasscodeLogin() {
      this.loginModel = 'passcode'
      this.$refs.accountForm && this.$refs.accountForm.resetFields()
      this.isLoginErrorInfo.isError = false
      this.isLoginErrorInfo.msg = ''
    },
    handleForgetPassword() {
      this.$router.push({
        name: 'forgetPassword'
      })
    },
    handleRegister() {
      this.$router.push({
        name: 'register'
      })
    },
    updateValicode() {
      this.codePicUrl += '?_=' + new Date().getTime()
    },
    handleSendPhoneCode() {
      const $ref = this.$refs.passcodeForm
      const phoneCode = this.phoneCode
      const passcodeForm = this.passcodeForm
      // 前端：手机号有效
      $ref.validateField('account', (errorMsg) => {
        if (errorMsg !== '') {
          return
        }
        this.genInteractionCodeMethods(phoneCode, () => {
          this.$service.sendCode({ phone: this.$encrypt(passcodeForm.account) })
        })
      })
    },
    handleCodeComplete(code) {
      this.authForm.tfAuthCode = code.join('')
    }
  },
  created() {
    this.updateValicode()
  }
}
</script>
<style lang="stylus" scoped>
.wrap
  width 1200px
  margin 0 auto
.el-main
  width 100%
  min-width 1400px
  height inherit
  overflow hidden
  position relative
#canvas
  position absolute
  left 0
  top 0
  z-index 1
.login-form
  width 350px
  color #797979
  background-color white
  -webkit-box-sizing border-box
  box-sizing border-box
  padding 40px
  position relative
  -webkit-animation fadeIn 2s ease
  animation fadeIn 2s ease
  position absolute
  z-index 100
  top 50%
  left 50%
  margin-top -214px
  margin-left 250px
  border-radius 4px
.login-form__btn
  border-width 0
  font-size 1.125rem
  height 2.82rem
  padding 0
  margin-top 1rem
  width 100%
  line-height 2.82rem
.login-form .el-row
  margin 0
.login-mode--wrapper
  display flex
  justify-content space-between
  align-items baseline
  .cut
    color #cecece
.login-model--account,
.login-model--passcode,
.login-function-btn
  color #302d2d
.login-model--account,
.login-model--passcode
  font-size 1rem
.login-model--account.active
.login-model--passcode.active
  color #FC4C00
.third-item--more
  width 166px
.third-item--less
  width 100px
  float right
.send-phone-code-btn
  text-align center
  color #f59a23
  border-radius 4px
  border 1px solid f59a23
  width 100%
  line-height 14px
  box-sizing border-box
  padding 0.575rem 0.625rem
  cursor pointer
  font-size 14px
  margin-top 3px
.send-phone-code-btn:hover
  background #fff3e6
.send-phone-code-btn[disabled]
  background #999999
  color white
  border 1px solid #999999
  font-size 12px
.pic-code--wrapper
  cursor pointer
  border 0.0625rem solid #dcdfe6
  border-radius 0.25rem
  height 34px
  overflow hidden
  width 100%
  text-align center
  img
    margin-right 20px
    margin-top 2px
    height 30px
    vertical-align top
.login-header
  height 60px
  display flex
  align-items center
.login-header__wrap
  width 1200px
  margin 0 auto
.login-main
  padding 0
  background #fff
.login-introduce
  width 1200px
  margin 40px auto
  text-align center
.login-introduce__warp
  display flex
  align-items center
  margin 0 -10px
.introduce-box
  width 25%
  box-sizing border-box
  padding 0 10px
.introduce-card
  display inline-flex
  align-items center
  justify-content space-between
  padding 20px
  background #fff
  border 1px solid #eaeaea
.introduce-card--content
  width 170px
  display inline-block
  text-align left
.introduce-card--title
  font-size 18px
  font-weight 600
  margin-bottom 10px
.introduce-card--tip
  font-size 14px
  color #888
  line-height 1.5
.login-body
  position relative
.login-footer
  background #fff
  padding 15px 0
  box-sizing border-box
  border-top 1px solid #eaeaea
  margin 0 auto
  text-align center
  color #cecece
  font-size 14px
  line-height 2
  .wrap
    display flex
    justify-content space-between
  .copyright
    color #666
.login-footer a
  text-decoration none
  color #666
.login-footer a:hover
  color #FF8B00
.el-carousel__item a
  display block
  width 100%
  height 100vh
.login-body .el-form
  margin-bottom 40px
.auth-tips
  padding 0 20px 10px 20px
.auth-row
  padding 0 20px
.login-btn-nav
  padding 0 20px
  .el-button
    width 100%
.login-error-info
  color #F56C6C
  font-size 12px

.logo
  height 3.125rem
  font-size 1rem
  .site-name
    display flex
    align-items center
    color #303133
    font-weight 400
    height inherit
    .site-name-img
      height 1.4rem
      padding-right 1rem
      img
        max-height 100%
      &.jia
        height 46px
    .site-name-title
      padding-left 1rem
      font-size 16px
      border-left 1px solid #ddd
</style>
